const IconSizes = {
    sm: 18,
    md: 20,
    lg: 24,
} as const;

const IconColors = {
    base: "var(--icon-base)",
    inverse: "var(--icon-inverse)",
    accent: "var(--icon-accent)",
    search: "var(--icon-search)",
} as const;

export { IconSizes, IconColors };
